"use strict";
var core_1 = require('@angular/core');
var TooltipOptions = (function () {
    function TooltipOptions(options) {
        Object.assign(this, options);
    }
    TooltipOptions.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    TooltipOptions.ctorParameters = [
        { type: Object, },
    ];
    return TooltipOptions;
}());
exports.TooltipOptions = TooltipOptions;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/components/tooltip/tooltip-options.class.js
// module id = 1217
// module chunks = 0